import { CaseStudyPageResolver } from "./CaseStudyPageResolver";
import { BasePageProviders } from "./PageProviders";

export const CaseStudyPageProviders = () => (
  <BasePageProviders>
    <CaseStudyPageResolver />
  </BasePageProviders>
);
